import React, { useState } from 'react'

import { Menu, Fade, MenuItem, Typography } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew'

import BrandMenu from './BrandMenu'
import ContextButton from './ContextButton'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menu: {
      '& .MuiMenu-paper': {
        width: '296px',
      },
      '& .MuiMenu-list': {
        padding: '0',
      },
    },
    listItemIcon: {
      width: '16px',
      height: '16px',
      marginRight: theme.spacing(2),
    },
    menuItem: {
      minHeight: '48px',
      backgroundColor: '#e6e6e6',
    },
  }),
)

interface ContextMenuProps {
  onHandleLogout: () => void
  onChangeBrand: (brand: string) => void
  agentName?: string
  theme: string
}

const ContextMenu: React.FC<ContextMenuProps> = ({
  onHandleLogout,
  onChangeBrand,
  agentName,
  theme,
}) => {
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setIsOpen(!isOpen)
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setIsOpen(!isOpen)
    setAnchorEl(null)
  }

  const handleLogout = () => {
    handleClose()
    onHandleLogout()
  }

  const changeBrand = (brand: string) => {
    handleClose()
    onChangeBrand(brand)
  }

  return (
    <>
      <ContextButton
        agentName={agentName}
        isOpen={isOpen}
        onHandleClick={handleClick}
        dataHook="context-menu"
      />
      <Menu
        elevation={3}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 72,
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        anchorEl={anchorEl}
        TransitionComponent={Fade}
        open={isOpen}
        onClose={handleClose}
        className={classes.menu}
      >
        <div>
          <BrandMenu onChangeBrand={changeBrand} theme={theme} />
          <MenuItem data-hook="logout-button" className={classes.menuItem} onClick={handleLogout}>
            <PowerSettingsNewIcon className={classes.listItemIcon} />
            <Typography variant="body1">Cerrar sesión</Typography>
          </MenuItem>
        </div>
      </Menu>
    </>
  )
}

export default ContextMenu
